export const SET_LIST_AGGREGATOR = 'SET_LIST_AGGREGATOR';
export const SET_LIST_SERVICE = 'SET_LIST_SERVICE';
export const SET_LIST_FORM = 'SET_LIST_FORM';
export const SET_BILLER_OF_FORM = 'SET_BILLER_OF_FORM';
export const CHECK_FORM_DELETION = 'CHECK_FORM_DELETION';
export const SET_SERVICE = 'SET_SERVICE';
export const SET_FORM = 'SET_FORM';
export const PROCESSING = 'PROCESSING';
export const PROCESSING_DONE = 'PROCESSING_DONE';
export const SET_LIST_BILLER = 'SET_LIST_BILLER';
export const SET_BILLER = 'SET_BILLER';
export const BILLER_ADD_NEW = 'BILLER_ADD_NEW';
export const BILLER_UPDATE = 'BILLER_UPDATE';
export const SET_ERROR_DELETE = 'SET_ERROR_DELETE';
export const PROCESSING_PREFIX = 'PROCESSING_PREFIX';
export const SET_LIST_BILLER_PREFIX = 'SET_LIST_BILLER_PREFIX';
export const PROCESSING_PREFIX_DONE = 'PROCESSING_PREFIX_DONE';
export const SET_LIST_BILLER_SERVICE = 'SET_LIST_BILLER_SERVICE';
export const SET_LIST_BANK = 'SET_LIST_BANK';
export const SET_BANK = 'SET_BANK';
export const SET_LIST_TRANSACTIONS = 'SET_LIST_TRANSACTIONS';
export const GET_TRANSACTION_DETAIL_MODAL_DATA =
  '  GET_TRANSACTION_DETAIL_MODAL_DATA';
export const SET_TRANSACTION_DETAIL_MODAL = 'SET_TRANSACTION_DETAIL_MODAL';
export const SET_TRANSACTION_REFUND_CONFIRM_MODAL =
  'SET_TRANSACTION_REFUND_CONFIRM_MODAL';
export const START_CANCEL_ORDER = 'START_CANCEL_ORDER';
export const UPDATE_CANCEL_ORDER = 'UPDATE_CANCEL_ORDER';
export const RESET_CANCEL_ORDER = 'RESET_CANCEL_ORDER';
export const SET_LIST_SETTLEMENT = 'SET_LIST_SETTLEMENT';
export const LOADING_SET_LIST_SETTLEMENT = 'LOADING_SET_LIST_SETTLEMENT';
export const SET_SETTLEMENT_MODAL_VISIBLE = 'SET_SETTLEMENT_MODAL_VISIBLE';
export const UPDATE_SETTLEMENT_UPLOAD_FILELIST =
  'UPDATE_SETTLEMENT_UPLOAD_FILELIST';
export const UPDATE_SETTLEMENT_UPLOAD_SUCCESS =
  'UPDATE_SETTLEMENT_UPLOAD_SUCCESS';
export const UPDATE_SETTLEMENT_UPLOAD_ERROR = 'UPDATE_SETTLEMENT_UPLOAD_ERROR';
export const UPDATE_SETTLEMENT_UPLOAD_LOADING =
  'UPDATE_SETTLEMENT_UPLOAD_LOADING';
export const OPEN_UPLOAD_SETTLEMENT_MODAL = 'OPEN_UPLOAD_SETTLEMENT_MODAL';
export const UPDATE_CHECK_SETTLEMENT_DATE_LOADING =
  'UPDATE_CHECK_SETTLEMENT_DATE_LOADING';
export const UPDATE_SETTLEMENT_FILE_UPLOADED =
  'UPDATE_SETTLEMENT_FILE_UPLOADED';
export const SET_LIST_BILLER_BANK_ACCOUNT = 'SET_LIST_BILLER_BANK_ACCOUNT';
export const SET_LIST_TNC = 'SET_LIST_TNC';
export const SET_DETAIL_TNC = 'SET_DETAIL_TNC';
export const SET_LIST_PAYMENT_METHOD = 'SET_LIST_PAYMENT_METHOD';
export const SET_LIST_PREFERRED_CHANNEL = 'SET_LIST_PREFERRED_CHANNEL';
export const SET_NON_MANDATORY_VA_PREFIX_BANK_LIST =
  'SET_NON_MANDATORY_VA_PREFIX_BANK_LIST';
export const SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS =
  'SET_BLACKLIST_PAYMENT_METHOD_IN_BILLERS';
